// This section is now handled by the FAQ accordion system
// The FAQ data is located in src/data/faq/mythos-positives-denken-faq.ts
export const faq = { id: 'faq', title: '', content: '' };
